export default {
  AUTHENTICATION: `${import.meta.env.VITE_API_URI}/backend`,
  DASHBOARD: `${import.meta.env.VITE_API_URI}/backend`,
  PROFILE: `${import.meta.env.VITE_API_URI}/backend`,
  PAYMENTS: `${import.meta.env.VITE_API_URI}/backend`,
  ERRORS: `${import.meta.env.VITE_API_URI}/errors-service`,
  X_AUTH: `${import.meta.env.VITE_API_URI}/x-auth`,
};
